import React from 'react';
import moment from 'moment';
import Icon from 'shared/components/icon';
import TextButton from 'src/components/text-button';
import colors from 'shared/aptitude/colors';

import TestimonialAvatar from './testimonial-avatar';
import 'stylesheets/components/college-testimonial.scss';

export interface TestimonialData {
  testimonialId: string;
  firstName: string;
  lastName: string;
  major: string;
  year?: string;
  graduationYear?: number;
  submittedAt?: string;
  body: string;
  avatarUrl?: string;
  helpfulnessCount: number;
  userMarkedHelpful: boolean;
}

interface Props {
  testimonial: TestimonialData;
  showHorizontalRule: boolean;
  toggleCollegeTestimonialHelpfulness: (id: string) => void;
  nonStudent?: boolean;
}

const yearToShorthandFormat = (integerYear: number) => `'${integerYear.toString().substr(-2)}`;

const Testimonial = ({
  testimonial,
  showHorizontalRule,
  toggleCollegeTestimonialHelpfulness,
  nonStudent,
}: Props) => {
  const {
    testimonialId,
    firstName,
    lastName,
    major,
    year,
    graduationYear,
    submittedAt,
    body,
    avatarUrl,
    helpfulnessCount,
    userMarkedHelpful,
  } = testimonial;

  const helpfulnessCounter = helpfulnessCount > 0 ? ` (${helpfulnessCount})` : '';
  const blueIconStyle = {color: colors.b500};
  const grayIconStyle = {color: colors.n600};

  return (
    <div className="about-testimonial-container" data-testid="about-testimonial">
      <div className="about-testimonial-student">
        <div className="about-testimonial-student-avatar">
          {avatarUrl ? <TestimonialAvatar url={avatarUrl} /> : <Icon iconType="user" />}
        </div>
        <div className="about-testimonial-student-info">
          <p className="about-testimonial-student-name">
            <strong>
              {firstName} {lastName ? lastName.charAt(0) : null}
            </strong>
          </p>
          <p>
            {(year || graduationYear) && (
              <span>
                {year
                  ? `${year} `
                  : `${graduationYear ? yearToShorthandFormat(graduationYear) : ''}`}
                <strong>·</strong>
              </span>
            )}
            {` ${major}`}
          </p>
          <p>{submittedAt && moment(new Date(submittedAt)).fromNow()}</p>
        </div>
      </div>
      <div className="about-testimonial-body">
        <p>&quot;{body}&quot;</p>
      </div>
      {!nonStudent && (
        <TextButton
          color="dark-grey"
          hoverColor="blue"
          icon={userMarkedHelpful ? 'check-circle' : 'check-circle-r'}
          iconPosition="left"
          iconStyle={userMarkedHelpful ? blueIconStyle : grayIconStyle}
          onClick={() => toggleCollegeTestimonialHelpfulness(testimonialId)}
        >
          {`Helpful ${helpfulnessCounter}`}
        </TextButton>
      )}
      {showHorizontalRule && <hr data-testid="testimonial-hr" />}
    </div>
  );
};

export default Testimonial;
